/**
 * The label shown for the signed-in user in the navbar. A profile with blank name
 * fields used to render NOTHING (which reads as "not signed in"), so fall back to
 * the account email; null only when there is no profile at all.
 */
export function navDisplayName(
  // `email` is a REQUIRED key on purpose: the RBAC `profile` object has no email, so
  // callers must pass it explicitly (from `user`) — omitting it is a type error.
  profile:
    | { first_name?: string | null; last_name?: string | null; email: string | null | undefined }
    | null
    | undefined,
): string | null {
  if (!profile) return null;
  const name = [profile.first_name, profile.last_name]
    .map((p) => (p ?? '').trim())
    .filter(Boolean)
    .join(' ');
  return name || (profile.email ?? '').trim() || null;
}
